<template>
  <el-row>
    <el-row type="flex" justify="end">
      <el-select
        v-model="phaseSelected"
        clearable
        size="mini"
        placeholder="Selecciona la Etapa"
        @change="onPhaseChange"
      >
        <el-option
          v-for="item in PhasesList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-col>
      <RabbeyTable4
        :border="true"
        :stripe="true"
        ref="table"
        url="/api/deals/DealReportByAgentOrSellers"
        :request-config="requestConfig"
        :columns="mapColumns"
        show-summary
        :summary-method="getSummaries"
        :classTable="{
          'table-box': true,
          'card-base': true,
          'card-shadow--medium': false
        }"
      />
    </el-col>
    <deal-report-detail ref="detail" @getUpdatedData="refreshData" />
    <!-- <DealReportCongratulations url="/api/deals/DealReportByAgentOrSellers" /> -->
  </el-row>
</template>

<script>
import HyperLinkSeller from "@/components/functionals/HyperLinkSeller.vue";
import DealReportDetail from "./DealReportDetail.vue";
import RabbeyTable4 from "@/components/RabbeyTable4.vue";
import { MONTHS_LIST_WITH_WIDTH } from "@/const";
import { formatMonto } from "@/utils";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
// import DealReportCongratulations from "@/views/modules/sales/reports/DealReportCongratulations.vue";

export default {
  name: "DealReportBySellers",
  props: {
    module: {
      type: String,
      default: null,
      requird: false
    },
    stages: {
      type: Array,
      default: () => [],
      required: false
    },
    supportSellerId: {
      type: Number,
      default: 0,
      required: false
    },
    sellerId: {
      type: [Number, String],
      default: "0",
      required: false
    },
    productId: {
      type: Number,
      default: 0,
      required: false
    },
    typeFilter: {
      type: String,
      default: "A"
    },
    year: {
      type: Number,
      default: new Date().getFullYear()
    },
    isClose: {
      type: Boolean,
      default: true
    },
    stage: {
      type: String,
      default: "5"
    }
  },
  components: {
    DealReportDetail,
    RabbeyTable4
    // DealReportCongratulations
  },
  data() {
    return {
      userType: "seller",
      statsDeal: [],
      columns: [
        {
          prop: "SalesPersonName",
          label: "Vendedor",
          fixed: true,
          minWidth: 260,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SalesPersonPhoto"
          },
          sortable: true
        }
      ],
      mountFormatter: new Intl.NumberFormat("en-US", {
        style: "decimal"
      }),
      phaseSelected: 0,
      PhasesList: []
    };
  },
  created() {
    this.GetDealsPhases();
  },
  computed: {
    title() {
      if (this.module !== null && this.module === "call-center") {
        return "agente";
      }

      return "vendedor";
    },
    requestConfig() {
      const module = this.module ?? "seller";
      return {
        params: {
          Year: this.year,
          CompanySelected: this.currentCompany,
          CompanyID: this.currentCompany,
          seller: module === "sales",
          BySeller: module === "sales",
          stage: parseInt(this.stage),
          close: this.isClose,
          ProductId: this.productId,
          salesPersonId: this.sellerId,
          SupportSellerId: this.supportSellerId,
          PhaseID: this.phaseSelected,
          ServiceRequestOption: this.typeFilter
        }
      };
    },
    mapColumns() {
      let columns = this.columns;
      let column = this.columns[0];
      if (this.module && this.module === "call-center") {
        column.label = "Agente";
        column.prop = "AgentName";
        column.attrs.imgKey = "AgentImageUrl";
      } else {
        column.label = "Vendedor";
        column.prop = "SalesPersonName";
        column.attrs.imgKey = "SalesPersonPhoto";
      }
      for (let i = 0; i < 12; i++) {
        const month = MONTHS_LIST_WITH_WIDTH[i];
        columns.push({
          prop: month.label,
          label: this.$t(`months.${month.label}`),
          name: this.$t(`months.${month.label}`),
          attrs: {
            openSelect: this.openSelect,
            getType: this.getType,
            month: i + 1
          },
          formatter: HyperLinkSeller,
          minWidth: month.width,
          sortable: true
        });
      }

      columns.push({
        prop: "Total",
        label: "Total",
        name: "Total",
        attrs: {
          isTotal: true,
          openSelect: this.openSelect,
          getType: this.getType,
          month: 0
        },
        formatter: HyperLinkSeller,
        minWidth: 110,
        sortable: true
      });
      return columns;
    }
  },
  methods: {
    formatMonto,
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => item[column.property]);
        sums[index] = values.reduce((prev, curr) => {
          if (typeof prev == typeof "") {
            prev = parseFloat(prev.replace(",", ""));
          }
          curr = parseFloat(curr.replace(",", ""));
          const value = parseFloat(curr);
          if (value) {
            let sum = prev + curr;
            sum = this.mountFormatter.format(sum);
            return sum;
          } else {
            return this.mountFormatter.format(prev);
          }
        }, 0);
      });
      return sums;
    },
    openSelect(props) {
      this.$refs.detail.show({
        year: this.year,
        PhaseID: this.phaseSelected,
        close: this.isClose,
        BySeller: this.module !== "call-center",
        ...props
      });
    },
    getType() {
      return this.typeFilter;
    },
    handleChangeType() {
      this.$nextTick(() => {
        this.$refs.table.table().doLayout();
      });
    },
    refreshData() {
      this.$refs.table.refreshTable();
    },
    async GetDealsPhases() {
      await this.$http.get("/api/deals/GetDealsPhases").then((response) => {
        this.PhasesList = response.data;
      });
    },
    onPhaseChange() {
      this.refreshData();
    }
  }
};
</script>
